import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import type { ReactNode } from 'react';
import { ROLES, useRoleStore } from '@/shared/session/roleStore';
import { useActingRole } from '@/shared/session/useActingRole';
import { accountMayOpen, accountRolesFor, rolesFor } from './navigation';

type Props = { path: string; children: ReactNode };

/** UX guard only: the backend enforces the same role rules on every request. */
export function RequireRole({ path, children }: Props) {
  const { role, demo, accountRole } = useActingRole();
  const setRole = useRoleStore((s) => s.setRole);
  const allowed = rolesFor(path);
  const fallback = allowed[0];
  const accountRoles = accountRolesFor(path);

  if (!accountMayOpen(path, accountRole, demo)) {
    return <Alert severity="info" variant="outlined">This screen is for {accountRoles.map((r) => ROLES[r].label).join(' or ')} accounts.</Alert>;
  }
  if (allowed.includes(role) || !fallback) return children;
  if (!demo) return <Alert severity="info" variant="outlined">This screen is for {allowed.map((r) => ROLES[r].label).join(' or ')}.</Alert>;

  return (
    <Alert
      severity="info"
      variant="outlined"
      action={
        <Button color="inherit" size="small" onClick={() => { setRole(fallback); }}>
          Switch to {ROLES[fallback].label}
        </Button>
      }
    >
      This screen is for {allowed.map((r) => ROLES[r].label).join(' or ')}.
    </Alert>
  );
}
